import _ from "lodash";

export default {
  isLoading: state => {
    return state.isLoading;
  },

  getAccessToken: state => {
    return state.access_token;
  },

  getRefreshToken: state => {
    return state.refresh_token;
  },

  getCurrentUser: state => {
    return state.currentUser;
  },

  getRole: state => {
    return _.get(state, "currentUser.attributes.role");
  }
};
